'use strict';

function CompanyCommentsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/visible-comments', {}, {
    "queryComments": {
      method: "GET",
      isArray: true,
      url: config.apiBase + '/companies/:companyId/comments'
    },
    'createComment': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/comments'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyCommentsService', ['$resource', 'config', CompanyCommentsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyCommentsService.js
// module id = 19
// module chunks = 0